"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = exports["default"] = {
  framerate: 24,
  images: [require('./sideSprite.png')],
  frames: [[3522, 2, 436, 808, 0, -33, 568], [2202, 2, 436, 808, 0, -33, 568], [3082, 2, 436, 808, 0, -33, 568], [2642, 2, 436, 808, 0, -33, 568], [2, 814, 436, 808, 0, -33, 568], [442, 814, 436, 808, 0, -33, 568], [2202, 814, 436, 806, 0, -33, 566], [1762, 814, 436, 806, 0, -33, 566], [3082, 814, 436, 806, 0, -33, 566], [2642, 814, 436, 806, 0, -33, 566], [1322, 814, 436, 806, 0, -33, 566], [882, 814, 436, 806, 0, -33, 566], [1762, 2, 436, 808, 0, -33, 568], [1322, 2, 436, 808, 0, -33, 568], [882, 2, 436, 808, 0, -33, 568], [442, 2, 436, 808, 0, -33, 568], [2, 2, 436, 808, 0, -33, 568]],
  animations: {
    idle2: {
      frames: [6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 8, 8, 9, 9, 9, 10, 10, 11, 11, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 12, 12, 12, 12, 12],
      speed: 1
    },
    idle1: {
      frames: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 3, 4, 4, 5, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      speed: 1
    },
    'talk loop': {
      frames: [13, 13, 13, 14, 14, 14, 15, 15, 15, 13, 13, 13, 15, 15, 15, 14, 14, 14, 12, 12, 15, 15, 15, 14, 14, 14, 15, 15, 15, 13, 13, 14, 14, 14, 14, 16, 16, 15, 15, 15],
      speed: 1
    }
  }
};